define('pages/player/player_page_view',[
  'backbone',
  'jquery',
  '_',

  'modules/player/player_view',

  'text!./player_page_template.html'
], function (Backbone, $, _,
             PlayerView,
             player_page_template) {
  'use strict';
  var View = Backbone.View.extend({

    initialize: function (opts) {
      _.extend(this, opts);

      this.subViews = [];

      this.render();
      this.renderPlayer();
    },

    template: _.template(player_page_template),
    subViews: [],

    events: {
      'click .js-switch-view': 'switchView'
    },

    render: function () {
      var playerName = this.params ? this.params.player_name : '';
      this.$el.html(this.template({ playerName: playerName }));
      return this;
    },

    renderPlayer: function () {
      this.player = new PlayerView({
        player_id: this.player_id,
        zone_id: this.params && this.params.zone_id
      });

      this.subViews.push(this.player);
      this.$('.player-page-content').html(this.player.$el);
    },

    switchView: function (evt) {
      var media_type;

      if (evt) {
        evt.preventDefault();
      }

      this.$('.js-switch-view').removeClass('active');
      $(evt.currentTarget).addClass('active');
      media_type = $(evt.currentTarget).attr('data-view');

      this.player.switchView(media_type);
    },

    remove: function () {
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    }
  });
  return View;
});

